var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import cx from 'clsx';
import { WarningCircle } from '@phosphor-icons/react';
import { Inline } from '../inline/Inline';
import { iconStyles, messageVariants } from './ValidationMessage.css';
export const ValidationMessage = React.forwardRef(function ValidationMessage(_a, ref) {
    var { children, className, variant = 'error' } = _a, rest = __rest(_a, ["children", "className", "variant"]);
    return (_jsxs(Inline, Object.assign({ alignY: "top", className: cx(messageVariants[variant], className), noWrap: true, spacing: 8 }, rest, { ref: ref, children: [_jsx(WarningCircle, { "aria-hidden": true, className: iconStyles, size: "1.25rem" }), children] })));
});
